/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ProductGroupsResponse as ModelsProductProductGroupsResponse } from '../models/Models/Product/product-groups-response';
import { v3ProductsProductGroupsGet$Json } from '../fn/products/v-3-products-product-groups-get-json';
import { V3ProductsProductGroupsGet$Json$Params } from '../fn/products/v-3-products-product-groups-get-json';
import { v3ProductsProductGroupsGet$Plain } from '../fn/products/v-3-products-product-groups-get-plain';
import { V3ProductsProductGroupsGet$Plain$Params } from '../fn/products/v-3-products-product-groups-get-plain';
import { v3ProductsProductGroupsGet$Xml } from '../fn/products/v-3-products-product-groups-get-xml';
import { V3ProductsProductGroupsGet$Xml$Params } from '../fn/products/v-3-products-product-groups-get-xml';

@Injectable({ providedIn: 'root' })
export class ProductsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v3ProductsProductGroupsGet()` */
  static readonly V3ProductsProductGroupsGetPath = '/v3/products/productGroups';

  /**
   * Gets a list of product groups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ProductsProductGroupsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ProductsProductGroupsGet$Plain$Response(params?: V3ProductsProductGroupsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsProductProductGroupsResponse>> {
    return v3ProductsProductGroupsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of product groups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ProductsProductGroupsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ProductsProductGroupsGet$Plain(params?: V3ProductsProductGroupsGet$Plain$Params, context?: HttpContext): Observable<ModelsProductProductGroupsResponse> {
    return this.v3ProductsProductGroupsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsProductProductGroupsResponse>): ModelsProductProductGroupsResponse => r.body)
    );
  }

  /**
   * Gets a list of product groups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ProductsProductGroupsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ProductsProductGroupsGet$Json$Response(params?: V3ProductsProductGroupsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsProductProductGroupsResponse>> {
    return v3ProductsProductGroupsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of product groups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ProductsProductGroupsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ProductsProductGroupsGet$Json(params?: V3ProductsProductGroupsGet$Json$Params, context?: HttpContext): Observable<ModelsProductProductGroupsResponse> {
    return this.v3ProductsProductGroupsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsProductProductGroupsResponse>): ModelsProductProductGroupsResponse => r.body)
    );
  }

  /**
   * Gets a list of product groups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ProductsProductGroupsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ProductsProductGroupsGet$Xml$Response(params?: V3ProductsProductGroupsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsProductProductGroupsResponse>> {
    return v3ProductsProductGroupsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of product groups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ProductsProductGroupsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3ProductsProductGroupsGet$Xml(params?: V3ProductsProductGroupsGet$Xml$Params, context?: HttpContext): Observable<ModelsProductProductGroupsResponse> {
    return this.v3ProductsProductGroupsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsProductProductGroupsResponse>): ModelsProductProductGroupsResponse => r.body)
    );
  }

}
